export enum DecisionType {
  approveAnnualAccount = "approveAnnualAccount",
  approveAuditorRemuneration = "approveAuditorRemuneration",
  approveCompanyBoardRemuneration = "approveCompanyBoardRemuneration",
  approveNominationCommitteeRemuneration = "approveNominationCommitteeRemuneration",
  assignsNewCompanyBoard = "assignsNewCompanyBoard",
  auditor = "auditor",
  boardAssignsSignature = "boardAssignsSignature",
  capitalIncreaseThroughBonusIssue = "capitalIncreaseThroughBonusIssue",
  changeCompanyBoardInArticlesOfAssociation = "changeCompanyBoardInArticlesOfAssociation",
  changeSignatureInArticlesOfAssociation = "changeSignatureInArticlesOfAssociation",
  companyName = "companyName",
  convertibleLoanPowerOfAttorney = "convertibleLoanPowerOfAttorney",
  dividend = "dividend",
  dividendPowerOfAttorney = "dividendPowerOfAttorney",
  electNominationCommittee = "electNominationCommittee",
  employmentOfManagingDirector = "employmentOfManagingDirector",
  freetext = "freetext",
  groupContributionByGeneralMeeting = "groupContributionByGeneralMeeting",
  increaseOfShareCapital = "increaseOfShareCapital",
  increaseShareCapitalPowerOfAttorney = "increaseShareCapitalPowerOfAttorney",
  acquireOwnSharesPowerOfAttorney = "acquireOwnSharesPowerOfAttorney",
  insertCompanyBoardInArticlesOfAssociation = "insertCompanyBoardInArticlesOfAssociation",
  insertSignatureInArticlesOfAssociation = "insertSignatureInArticlesOfAssociation",
  procura = "procura",
  reductionOfShareCapital = "reductionOfShareCapital",
  removeCompanyBoardFromArticlesOfAssociation = "removeCompanyBoardFromArticlesOfAssociation",
  removeSignatureFromArticlesOfAssociation = "removeSignatureFromArticlesOfAssociation",
  reverseSplitShare = "reverseSplitShare",
  splitShare = "splitShare",
  noAuditor = "noAuditor",
  changeArticlesOfAssociation = "changeArticlesOfAssociation",
  conversionOfShares = "conversionOfShares",
  electionOfCompanyBoard = "electionOfCompanyBoard",
}

export const isDecisionType = (o: unknown): o is DecisionType =>
  typeof o === "string" && o in DecisionType;
